import { getCurrentScope, onScopeDispose, shallowRef } from "vue";
//#region src/v2/features/modal/use-lazy-api-client.ts
/** Load and mount the client only when requested, retaining the latest open intent during loading. */
var useLazyApiClient = ({ eventBus, load, status = shallowRef("idle") }) => {
	const scope = getCurrentScope();
	const client = shallowRef(null);
	let disposed = false;
	let loading = false;
	let pending = null;
	const unsubscribeOpen = eventBus.on("ui:open:client-modal", (payload) => {
		pending = { payload };
		status.value = "loading";
		if (loading) return;
		loading = true;
		load().then((createClient) => {
			if (disposed || !pending) return;
			client.value = (scope ? scope.run(createClient) : createClient()) ?? null;
			if (!client.value) return;
			unsubscribeOpen();
			unsubscribeClose();
			eventBus.emit("ui:open:client-modal", pending.payload);
		}).catch((error) => {
			if (!disposed && pending) status.value = "error";
			console.error("[@scalar/api-client] Could not load the API client modal.", error);
		}).finally(() => {
			pending = null;
			loading = false;
			if (status.value === "loading") status.value = "idle";
		});
	});
	const unsubscribeClose = eventBus.on("ui:close:client-modal", () => {
		pending = null;
		status.value = "idle";
	});
	onScopeDispose(() => {
		disposed = true;
		status.value = "idle";
		pending = null;
		unsubscribeOpen();
		unsubscribeClose();
		client.value?.app.unmount();
	}, true);
	return client;
};
//#endregion
export { useLazyApiClient };

//# sourceMappingURL=use-lazy-api-client.js.map